/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
	Filter,
	FilterFromJSON,
	FilterToJSON,
	MentorshipDTO,
	MentorshipDTOFromJSON,
	MentorshipDTOToJSON,
	MentorshipDTOPagedResponse,
	MentorshipDTOPagedResponseFromJSON,
	MentorshipDTOPagedResponseToJSON,
} from "../models";

export interface ApiMentorshipProposalGetAllGetRequest {
	searchTerm?: string;
	companies?: Array<string>;
	faculties?: Array<string>;
	page?: number;
	pageSize?: number;
}

export interface ApiMentorshipProposalGetByIdIdGetRequest {
	id: string;
}

/**
 *
 */
export class MentorshipProposalApi extends runtime.BaseAPI {
	/**
	 */
	async apiMentorshipProposalGetAllGetRaw(
		requestParameters: ApiMentorshipProposalGetAllGetRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<MentorshipDTOPagedResponse>> {
		const queryParameters: any = {};

		if (requestParameters.searchTerm !== undefined) {
			queryParameters["SearchTerm"] = requestParameters.searchTerm;
		}

		if (requestParameters.companies) {
			queryParameters["Companies"] = requestParameters.companies;
		}

		if (requestParameters.faculties) {
			queryParameters["Faculties"] = requestParameters.faculties;
		}

		if (requestParameters.page !== undefined) {
			queryParameters["Page"] = requestParameters.page;
		}

		if (requestParameters.pageSize !== undefined) {
			queryParameters["PageSize"] = requestParameters.pageSize;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/MentorshipProposal/GetAll`,
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			MentorshipDTOPagedResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiMentorshipProposalGetAllGet(
		requestParameters: ApiMentorshipProposalGetAllGetRequest = {},
		initOverrides?: RequestInit
	): Promise<MentorshipDTOPagedResponse> {
		const response = await this.apiMentorshipProposalGetAllGetRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 */
	async apiMentorshipProposalGetByIdIdGetRaw(
		requestParameters: ApiMentorshipProposalGetByIdIdGetRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<MentorshipDTO>> {
		if (requestParameters.id === null || requestParameters.id === undefined) {
			throw new runtime.RequiredError(
				"id",
				"Required parameter requestParameters.id was null or undefined when calling apiMentorshipProposalGetByIdIdGet."
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/MentorshipProposal/GetById/{id}`.replace(
					`{${"id"}}`,
					encodeURIComponent(String(requestParameters.id))
				),
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			MentorshipDTOFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiMentorshipProposalGetByIdIdGet(
		requestParameters: ApiMentorshipProposalGetByIdIdGetRequest,
		initOverrides?: RequestInit
	): Promise<MentorshipDTO> {
		const response = await this.apiMentorshipProposalGetByIdIdGetRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 */
	async apiMentorshipProposalGetMentorshipsProposalFiltersGetRaw(
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<Array<Filter>>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/MentorshipProposal/GetMentorshipsProposalFilters`,
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			jsonValue.map(FilterFromJSON)
		);
	}

	/**
	 */
	async apiMentorshipProposalGetMentorshipsProposalFiltersGet(
		initOverrides?: RequestInit
	): Promise<Array<Filter>> {
		const response =
			await this.apiMentorshipProposalGetMentorshipsProposalFiltersGetRaw(
				initOverrides
			);
		return await response.value();
	}
}
